export const getStudentFullName = (student) =>
  student.fullName || `${student.firstName || ''} ${student.lastName || ''}`.trim();

export const getStudentEmail = (student) =>
  student.emailAddress || student.email || '';

export const buildAllStudents = (students, softDeletedStudents, showSoftDeleted) =>
  showSoftDeleted ? [...students, ...softDeletedStudents] : students;

export const filterAndSortStudents = (students, { searchTerm, sortBy, sortOrder }) =>
  students
    .filter((student) => {
      const fullName = getStudentFullName(student);
      const email = getStudentEmail(student);
      const term = (searchTerm || '').toLowerCase();

      const studentId = String(student.id || '').toLowerCase();
      const employeeId = String(student.employeeId || '').toLowerCase();
      const phone = String(student.phoneNumber || student.mobile || '').toLowerCase();

      if (!term) return true;
      return (
        (fullName && fullName.toLowerCase().includes(term)) ||
        (email && email.toLowerCase().includes(term)) ||
        (studentId && studentId.includes(term)) ||
        (employeeId && employeeId.includes(term)) ||
        (phone && phone.includes(term))
      );
    })
    .sort((a, b) => {
      let aValue = a[sortBy];
      let bValue = b[sortBy];

      if (sortBy === 'fullName') {
        aValue = getStudentFullName(a);
        bValue = getStudentFullName(b);
      } else if (sortBy === 'emailAddress') {
        aValue = getStudentEmail(a);
        bValue = getStudentEmail(b);
      } else if (sortBy === 'role') {
        aValue = a.role?.value || '';
        bValue = b.role?.value || '';
      } else if (sortBy === 'country') {
        aValue = a.country?.name || '';
        bValue = b.country?.name || '';
      }

      if (typeof aValue === 'string') {
        aValue = aValue.toLowerCase();
        bValue = bValue.toLowerCase();
      }

      if (sortOrder === 'asc') {
        return aValue < bValue ? -1 : aValue > bValue ? 1 : 0;
      }
      return aValue > bValue ? -1 : aValue < bValue ? 1 : 0;
    });
